
/**
 * 千分位格式（字符）
 * @param symbol
 * @returns {string}
*/

interface String {
    thousands(): string,

}
String.prototype.thousands = function (): string {
    let price = this.toString().replace('.00', '')
    return price.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")
}

 
/**
 * 千分位格式（数字）
 * @param symbol
 * @returns {string}
 */
interface Number {
    thousands(): string
}                
Number.prototype.thousands = function (): string {
    return this.toString().thousands()
}
interface String {
    webpFilters(): string,

}
// webp图片过滤 
String.prototype.webpFilters = function (): string {
    if(!this) return this
    let reg = /^(https?:\/\/image.kilimall.com|https?:\/\/image.kilitest.com)(.+\/)+.+(\.(png|jpg|jpeg|svg|psd|bmp|tif|webp))$/i
  // 支持webp图片且是域名下面的 没有webp的 加上webp
  if (document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') >= 0 && !this.toString().includes('.webp') && reg.test(this.toString())) {
    return this + '.webp'
    //  不支持webp的 且 图片域名下 有带webp的 去掉.webp
  } else if(document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') != 0 &&this.toString().includes('.webp') && reg.test(this.toString())){
    return this.substring(0,this.length-5)
  } else {
    return this.toString()
  }
}


/**
 * 创建存储LocalStorage对象
 */
var MemoryStorage:any = window.MemoryStorage
var lStorage = function(): any {
    var DB: any
    try {
        var x = 'test-localstorage-' + Date.now()
        localStorage.setItem(x, x)
        var y = localStorage.getItem(x)
        localStorage.removeItem(x)
        if (y !== x) { throw new Error() }
            DB = localStorage 
        } catch (e) {
            DB = new window.MemoryStorage('my-app')
        }
    return DB
}
var common = {
    /**
     * 存储
     * @param key 键名
     * @param value 字符串内容
     * @param key 有效期， 默认一天
     */
    setStorage: (key: string, value: any, day: number = 1): void => {
        
        var expire = new Date()
        expire.setTime(expire.getTime() + day * 24 * 3600 * 1e3)
        var store = {
            value: value,
            expire: expire
        }
        lStorage().setItem(key, JSON.stringify(store))
    },
    /**
     * 取值
     * @param key 键名
     */
    getStorage: (key: string): any => {

        if (lStorage().getItem(key)) {
            var store = JSON.parse(lStorage().getItem(key))
            var now_time = new Date()
            var expire = new Date(store.expire)
            // 检查过期
            if (now_time.getTime() > expire.getTime()) {
                return null
            } else {
                return store.value
            }
            // end 检查过期
        } else {
            return null
        }
    },
    /**
     * 删除
     * @param key 键名
     */
    delStorage: (key: string): void => {
        lStorage().removeItem(key)
    },

    /**
     * 老WAP域名
     */
    old_url: () => {
        // const origin = window.location.origin;
        // if(process.env.NODE_ENV === 'production') {
        //     return 'https://h5.kilimall.co.ke';
        // }
        return window.location.origin.replace('m.','h5.')
    },
    
    /**
     * 通用类型跳转
     * @param type  跳转类型
     * @param data  跳转value  
     */
    goTo: function(type: string, data: string, router: any = null) {
        if(!data) return false
        console.log(`类型：${type}, value：${data}`);
        let origin = common.old_url()
        
        let tmpUrl = '';
        switch (type) {        
          case "keyword":
            // 搜索关键词
            tmpUrl = '/search?bind_keywords=' + data
            break;
          case "special":
            // 专题页
            tmpUrl = origin + "/special/" + data;
            break;
          case "url":  
            tmpUrl = data;
            break;
          case "goods":
            // 商品详情页
            tmpUrl = '/goods/' + data
            break;
          case "store":             
            // 店铺首页
            tmpUrl = '/shop/' + data
            break;
          case "goods_class":
            // 搜索分类
            tmpUrl = `/search?bind_cid=${data}&gc_id=${data}`
            break;
        }
        if(router && tmpUrl.indexOf('http://') == -1 && tmpUrl.indexOf('https://') == -1) {
            router.push(tmpUrl);
        }
        else {
            window.location.href = tmpUrl;
        }

    },
    /**
     * 日期格式化
     * 
    */
    tiemstap:function(fmt:any):String{
        const time = new Date(fmt);
        const Y = time.getFullYear()
        const M = (time.getMonth() + 1).toString().padStart(2, '0')
        const D = time.getDate().toString().padStart(2, '0')
        const h = time.getHours().toString().padStart(2, '0')
        const m = time.getMinutes().toString().padStart(2, '0')
        const s = time.getSeconds().toString().padStart(2, '0')

        return `${Y}-${M}-${D} ${h}:${m}:${s}`
    },
    /**
     * 英文日期
     */
    get_data_str_fn: (date: number) => {
        if(!date) return ''
        let data_params = date * 1000
        var dt = new Date(data_params); 
        var m = new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec"); 
        // var w = new Array("Monday","Tuseday","Wednesday","Thursday","Friday","Saturday","Sunday"); 
        var d = new Array("st","nd","rd","th"); 
        let mn = dt.getMonth(); 
        let wn = dt.getDay(); 
        let dn = dt.getDate(); 
        var dns; 
        // if(((dn%10)<1) ||((dn%10)>3)){ 
        //   dns = d[3]; 
        // }  else { 
        //   dns = d[(dn%10)-1];
        //   if((dn==11)||(dn==12)){ 
        //     dns = d[3]; 
        //   } 
        // } 
        return m[mn]+"&nbsp;" + dn + ", " + dt.getFullYear()
    },
     /**
     * 唤醒KilimallAPP
     * 
    */
   jumpToApp:function(id:any) {
      var userAgent = navigator.userAgent
      if (userAgent.indexOf('Android') > -1 && userAgent.indexOf('kilimall,android') < 0) {
        // 在android内，不在kilimall app内
        // window.location.href = "kiliapp://kilimall?type=4&data=" + this.$route.params.goodsid;
        var ifr = document.createElement('iframe')
        ifr.src = 'kiliapp://kilimall?type=4&data=' + id
        ifr.style.display = 'none'
        document.body.appendChild(ifr)
      }
    },
    /**
     * 金额格式保留小数位
     * @param num 数值
     * @param decimal 设置保留的小数位数
     * @param str 金额面值
     */
    parsePrice: function (num: any, decimal = 2, str = 'KSh ') {
        num = parseFloat((num + "").replace(/[^\d\.-]/g, "")).toFixed(decimal) + "";
        let l = num.split(".")[0].split("").reverse();
        let r = num.split(".")[1];
        let t = "";
        for (let i = 0; i < l.length; i++) {
            t += l[i];
        }
        return str + t.split("").reverse().join("") + "." + r;
    }
}
/**
 * 挂载至window
 */
interface Window {
    common: any,
    gtag: any,
    dataLayer: any,
    appBean: any,
    WebViewJavascriptBridge: any,
    handleCredentialResponse: Function,
    androidWebObject: any
}

Window.prototype.common = common
Window.prototype.appBean = window.appBean
Window.prototype.WebViewJavascriptBridge = window.WebViewJavascriptBridge
Window.prototype.handleCredentialResponse = window.handleCredentialResponse
